import langs from 'langs';
import i18n from '../i18n';

const langCode = {
  convertLanguageCode(lang = 'en') {
    let languageCode = [
      {language: 'zh_tw', langCode: 'cht'},
      {language: 'zh-tw', langCode: 'cht'},
      {language: 'zh_cn', langCode: 'chs'},
      {language: 'zh-cn', langCode: 'chs'},
      {language: 'en', langCode: 'enu'},
      {language: 'es', langCode: 'esp'},
      {language: 'pt', langCode: 'ptb'},
      {language: 'it', langCode: 'ita'},
      {language: 'de', langCode: 'deu'},
      {language: 'ja', langCode: 'jpn'},
      {language: 'ko', langCode: 'kor'},
      {language: 'fr', langCode: 'fra'},
      {language: 'tr', langCode: 'tur'},
      {language: 'id', langCode: 'ind'},
      {language: 'ru', langCode: 'rus'},
      {language: 'th', langCode: 'tha'},
      {language: 'gn', langCode: 'grn'},
      {language: 'he', langCode: 'heb'},
      {language: 'ar', langCode: 'ara'},
      {language: 'pl', langCode: 'pol'},
      {language: 'tl', langCode: 'tgl'},
      {language: 'ro', langCode: 'ron'},
      {language: 'af', langCode: 'afr'},
      {language: 'uk', langCode: 'ukr'},
      {language: 'el', langCode: 'ell'},
      {language: 'sv', langCode: 'swe'},
      {language: 'hu', langCode: 'hun'},
      {language: 'bg', langCode: 'bul'},
      {language: 'da', langCode: 'dan'},
      {language: 'hr', langCode: 'hrv'},
      {language: 'vi', langCode: 'vie'},
      {language: 'nl', langCode: 'nld'},
    ];
    for (let l in languageCode) {
      if (languageCode[l].language === lang.toLowerCase()) {
        return languageCode[l].langCode;
      }
    }
    let target = langs.where('1', i18n.language);
    if (target) {
      return target['3'];
    }
    return 'enu';
  },
};

export default langCode;
